module.exports = __webpack_public_path__ + "img/coach.48243d86.svg";